module.exports = __webpack_public_path__ + "static/media/เถาะ.091a118b.jpg";